import { isObject } from "lodash";
import SocketWorker from "./SocketWorker"

// Os chamadores usam duas formas: { user: { companyId, id } } e
// { companyId, userId }. Ler só a primeira fazia a segunda chegar com
// identidade undefined no SocketWorker.
export function socketConnection(params) {
  let userId = "";
  let companyId = "";

  if (isObject(params)) {
    companyId = params?.user?.companyId ?? params?.companyId;
    userId = params?.user?.id ?? params?.userId;
  }

  return SocketWorker(companyId, userId)
}
